<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cDSCUK/image/FC-9781398406179.jpg?1685790893668" alt="This image is the cover for the book The Flared Black Skirt"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Flared Black Skirt
      </h1>
      <p class="bookDescription body article font2">
        <p>In this insightful and thought-provoking selection of poems, the reader is taken on a journey through life and death, love and heartbreak, joy and hardship: in other words, human existence in its myriad aspects. Written in deceptively simple language and often in the form of homilies and riddles, these poems cast the familiar in an unfamiliar light. Skilfully employing repeating patterns, personification and metaphor, the author offers a compelling reflection on who we are and how we navigate the world around us.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Joseph
      </h2>
      
      <p class="authorDescription body article">Mary Joseph lives in London, England. She shares her busy schedule with family and friends while working in the financial service of a private company, enjoys looking after her bunnies and being a musician. She decided to write this book and share her passion with her readers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?615b0a64